import React from 'react';

import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';

const YamlViewer = ({ yamlString }) => {
    return (
        <div>
            <SyntaxHighlighter
                language="yaml"
                customStyle={{
                    // fontSize: '0.875rem',
                    lineHeight: '1.25rem',
                    // fontFamily: 'Outfit, ui-sans-serif, system-ui, sans-serif',
                }}
                codeTagProps={{
                    fontSize: '0.875rem',
                    // lineHeight: '1.25rem',
                    fontFamily: 'Outfit, ui-sans-serif, system-ui, sans-serif',
                }}
            >
                {yamlString}
            </SyntaxHighlighter>
        </div>
    );
};

export default YamlViewer;
